import { useState } from "react";
import axios from "axios";
import { API, apiError } from "@/lib/api";
import { CheckCircle, CircleNotch, ClipboardText, LockSimple } from "@phosphor-icons/react";

const EMPTY = { name: "", phone: "", work_type: "", message: "", website: "" };
export const WORK_TYPES = ["Construção nova", "Remodelação", "Ampliação", "Pintura", "Canalização", "Eletricidade", "Outro"];

/** "Pedir orçamento" form for Construção sites. `ui` carries the classes of the site design it sits in. */
export function QuoteRequestForm({ slug, ui, disabled = false }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (disabled) return;
    setError("");
    if (!/^[\d\s+()-]{7,20}$/.test(f.phone.trim())) return setError("Indique um telefone válido.");
    if (!f.work_type) return setError("Escolha o tipo de obra.");
    setBusy(true);
    try { await axios.post(`${API}/public/site/${slug}/quote-requests`, f); setDone(true); setF(EMPTY); }
    catch (err) { setError(apiError(err, "Não foi possível enviar o pedido.")); }
    setBusy(false);
  };
  if (done) return (
    <div className={`flex flex-col items-center gap-2 p-8 text-center ${ui.card}`} data-testid="quote-request-success">
      <CheckCircle size={44} weight="fill" className={ui.accentText} />
      <h3 className="text-xl font-semibold">Pedido enviado!</h3>
      <p className={`text-sm ${ui.muted}`}>Vamos contactá-lo em breve por telefone ou WhatsApp.</p>
      <button onClick={() => setDone(false)} className={`mt-1 text-sm font-semibold underline ${ui.accentText}`} data-testid="quote-request-new-btn">Fazer outro pedido</button>
    </div>
  );
  return (
    <form onSubmit={submit} className={`grid grid-cols-1 gap-3 p-5 sm:grid-cols-2 ${ui.card}`} data-testid="quote-request-form">
      <label className="min-w-0 space-y-1.5 text-sm font-medium">Nome<input required minLength={2} maxLength={80} disabled={disabled} value={f.name} onChange={set("name")} autoComplete="name" className={ui.field} data-testid="quote-name" /></label>
      <label className="min-w-0 space-y-1.5 text-sm font-medium">Telefone / WhatsApp<input type="tel" required maxLength={20} disabled={disabled} value={f.phone} onChange={set("phone")} placeholder="+238 ..." autoComplete="tel" className={ui.field} data-testid="quote-phone" /></label>
      <label className="min-w-0 space-y-1.5 text-sm font-medium sm:col-span-2">Tipo de obra
        <select required disabled={disabled} value={f.work_type} onChange={set("work_type")} className={ui.field} data-testid="quote-work-type">
          <option value="">Escolha…</option>{WORK_TYPES.map((t) => <option key={t}>{t}</option>)}
        </select></label>
      <label className="min-w-0 space-y-1.5 text-sm font-medium sm:col-span-2">Mensagem<textarea rows={4} maxLength={1500} disabled={disabled} value={f.message} onChange={set("message")} placeholder="Descreva a obra: local, dimensões, prazos…" className={ui.field} data-testid="quote-message" /></label>
      <input type="text" tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} className="hidden" aria-hidden="true" />
      {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700 sm:col-span-2" data-testid="quote-error">{error}</p>}
      <button type="submit" disabled={disabled || busy} className={`flex h-14 items-center justify-center gap-2 text-base font-semibold disabled:cursor-not-allowed disabled:opacity-80 sm:col-span-2 ${ui.button}`} data-testid="quote-submit">
        {busy ? <CircleNotch size={20} className="animate-spin" /> : <><ClipboardText size={20} weight="bold" /> Pedir orçamento</>}
      </button>
      {disabled && <p className={`flex items-center justify-center gap-1.5 text-xs sm:col-span-2 ${ui.muted}`} data-testid="quote-demo-note"><LockSimple size={12} /> Ativo quando o site for oficial</p>}
    </form>
  );
}
